// extracted by mini-css-extract-plugin
export default {"textPart":"Paragraph_textPart__QPMyI","title":"Paragraph_title__VEZ8H","mainText":"Paragraph_mainText__kh1SX","less":"Paragraph_less__2SRNt"};